import { Alert, cn } from '@noorden-insurtech/alba-design-system';
import {
  type BrokerWriteGuard,
  resolveBrokerInactiveNotice,
} from '../utils/broker-status.util';

type BrokerInactiveNoticeProps = {
  /**
   * Guards das ações da tela. Guard `null`/`undefined` (ação fora da tela)
   * é ignorado.
   */
  guards: ReadonlyArray<BrokerWriteGuard | null | undefined>;
  className?: string;
};

/**
 * Aviso único de corretora inativa da tela, logo abaixo do cabeçalho. Os
 * botões ficam desabilitados com o motivo no `title`; aqui é um aviso só,
 * não importa quantas ações a tela trava.
 */
export function BrokerInactiveNotice({
  guards,
  className,
}: BrokerInactiveNoticeProps) {
  const notice = resolveBrokerInactiveNotice(guards);
  if (!notice) return null;

  // shrink-0: o Page.Root é uma coluna flex com altura fixa (h-full) e, sem
  // isso, o alerta encolhe e o texto sai cortado.
  return (
    <Alert.Root status='error' className={cn('shrink-0', className)}>
      <Alert.Icon />
      <Alert.Content>
        <Alert.Description>{notice}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
}
